module.exports = __webpack_public_path__ + "img/Ukraine.7fb901bc.png";